import { provide } from '@/util/container';
import { XLS_IMPORTER } from '.';
import XlsxImporter from '@/features/app-enterprise-project/views/enterprise-project/imports/xlsx-importer';

export default provide(XLS_IMPORTER, async () => {
  return new XlsxImporter();
});
